// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const poliwrath: PokeData = {
  "id": 62,
  "name": "poliwrath",
  "height": 13,
  "weight": 540,
  "base_experience": 230,
  "types": [
    PokeType.WATER,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "pound",
    "double-slap",
    "body-slam",
    "double-edge",
    "mist",
    "water-gun",
    "hydro-pump",
    "bubble-beam",
    "submission",
    "hypnosis",
    "haze",
    "bubble",
    "mind-reader",
    "belly-drum",
    "dynamic-punch",
    "rain-dance",
    "superpower",
    "bulk-up",
    "mud-shot",
    "earth-power",
    "circle-throw"
  ],
  "moves": [
    "body-slam",
    "hydro-pump",
    "bubble-beam",
    "bubble",
    "rain-dance",
    "superpower",
    "bulk-up",
    "mud-shot",
    "earth-power",
    "double-kick",
    "close-combat",
    "water-spout",
    "life-dew"
  ],
  "evolution_chain": {
    "id": 26,
    "item": null,
    "species": [
      {
        "name": "poliwag",
        "order": 65,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "poliwhirl",
        "order": 66,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 60,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "poliwrath",
        "order": 67,
        "types": [
          PokeType.WATER,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 61,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "water-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "politoed",
        "order": 68,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 61,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 142,
    "speed": 109,
    "ability_power": 148
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
